export function isManagerDeleting({ deletingManagerId, manager }) {
  return manager?.id === deletingManagerId
}
